import { useContext } from "react";
import { UnpayActionContext } from "./UnpayActionContext";

function usePrepareUnpay() {
  const { setElementId, setShowModal } = useContext(UnpayActionContext);
  return (id: any) => {
    setElementId(id);
    setShowModal(true);
  };
}

export default usePrepareUnpay;
